import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import AccountChoice from 'app/common/components/AccountChoice';
import Link from 'app/common/components/Link';
import Menu, { MenuSection } from 'app/common/components/Menu';
import { attachAccountIdToUrl } from 'app/common/middlewares/accountSwitcherMiddleware';
import 'app/viewport/components/AccountSwitcher.scss';

const bem = bemify('account-switcher');

const AccountSwitcherItem = props => (
  <Link className={bem('__item', props.className)} href={props.href}>
    <AccountChoice id={props.id} isActive={props.isActive} name={props.name} />
  </Link>
);

const AccountSwitcher = createReactClass({
  displayName: 'AccountSwitcher',
  mixins: [PureRenderMixin],

  propTypes: {
    accounts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        isActive: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
    isStandalone: PropTypes.bool.isRequired,
    switcherUrl: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      isStandalone: true,
    };
  },

  render() {
    const { props } = this;
    const items = props.accounts.map(account => ({
      href: attachAccountIdToUrl(account.id, props.switcherUrl),
      label: account.name,
      value: account.id,
      ...account,
    }));
    const Component = props.isStandalone ? Menu : MenuSection;
    return (
      <Component
        {...props}
        className={bem(props.className)}
        items={items}
        listClassName={bem('__list')}
        MenuItem={AccountSwitcherItem}
        title="Switch Account"
      />
    );
  },
});

export default AccountSwitcher;
